<template>
  <v-container>
    <div style="display: flex; justify-content: flex-end;">
      <!-- <v-col cols="11"> </v-col> -->
      <span v-if="showLoader">
        <LoaderProgress></LoaderProgress>
      </span>
    </div>

    <div
      :key="val.customer_id"
      v-for="val in alertsData"
      style="border-style=solid"
    >
      <v-row @click="goingIntoCustomer(val.customer_id)">
        <v-col>
          <v-btn class="white--text block" dark color="primary">
            {{ val.customer_name }}</v-btn
          >
        </v-col>
      </v-row>

      <v-row style="margin-bottom: 20px; ">
        <v-col
          v-bind:key="mac.machine_id"
          v-for="mac in val.value_ind_cust"
          style="width: 100%; margin-bottom: 20px;"
          cols="12"
          sm="12"
          md="6"
          lg="4"
        >
          <!-- <v-col> -->
          <super_admin_guage v-bind:gag="mac.machine_up_time" />
          <!-- </v-col> -->
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>
<script>
import axios from "axios";
import LoaderProgress from "../components/progressLoader";

// import constants from "../constants";
import router from "../router";
import super_admin_guage from "../components/superAdminGauge.vue";

export default {
  components: {
    super_admin_guage,
    LoaderProgress,
  },
  prop: ["apqData"],

  data: () => ({
    alertsData: [],
    super_data: [],
    showLoader: false,
  }),

  beforeMount() {
    console.log("checlong before mouted");
    this.super_user_method();
  },
  methods: {
    goingIntoCustomer(id) {
      console.log("checkign id", id);
      sessionStorage.removeItem("route_first_option");

      sessionStorage.setItem("route_first_option", "/");
      sessionStorage.setItem("super_to_user_org_id", `${id}`);

      router.push("/");

      //  this.$root.$emit('value_of_checkbox', gag.customer_id);
    },
    timeConverter: (UNIX_timestamp) => {
      // let a = new Date(UNIX_timestamp * 1000);
      let a = new Date((UNIX_timestamp - 19800) * 1000);
      let months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      let year = a.getFullYear();
      let month = months[a.getMonth()];
      let date = a.getDate();
      let hour = a.getHours();
      let min = a.getMinutes();
      let sec = a.getSeconds();
      let time =
        date + " " + month + " " + year + " " + hour + ":" + min + ":" + sec;
      return time;
    },
    super_user_method: function() {
      let config = {
        method: "get",
        url: `${this.$config.backend_url}/getSuperUserDetails`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      };
      this.showLoader = true;
      axios(config)
        .then((response) => {
          this.showLoader = false;
          console.log("response--parameter names", response.data.data);
          let val = response.data.data || [];
          let newValue = [];
          for (let i = 0; i < val.length; i++) {
            console.log("checking value", val[i]);
            let customerDetails = val[i]["value_ind_cust"] || [];
            let listMachines = [];
            if (customerDetails != []) {
              for (
                let insideCust = 0;
                insideCust < customerDetails.length;
                insideCust++
              ) {
                console.log(
                  "CHekcing value",
                  customerDetails[insideCust].machine_up_time,
                  customerDetails[insideCust].machine_up_time.start_time,
                  "also",
                  customerDetails[insideCust].machine_up_time
                );
                let start =
                  customerDetails[insideCust].machine_up_time.start_time;
                let end = customerDetails[insideCust].machine_up_time.end_time;
                let hours = Math.floor(
                  customerDetails[insideCust].machine_up_time.total_minutes / 60
                );
                if (end - start == 3600) {
                  let d = new Date();
                  start = d.setHours(0, 0, 0, 0) / 1000;
                }
                let minutes =
                  customerDetails[insideCust].machine_up_time.total_minutes %
                  60;
                let curr_value = hours + " Hrs :" + minutes + " Mins";
                let totalTime = (end - start) / 60;
                hours = Math.floor(totalTime / 60);
                minutes = totalTime % 60;
                let maxValue = hours + " Hrs :" + minutes.toFixed() + " Mins";
                let timeStamp = this.timeConverter(Date.now() / 1000);

                let series = (
                  (customerDetails[insideCust].machine_up_time.total_minutes /
                    totalTime) *
                  100
                ).toFixed(2);
                customerDetails[insideCust].machine_up_time.component_name =
                  customerDetails[insideCust].machine_name;
                customerDetails[insideCust].machine_up_time.id =
                  customerDetails[insideCust].machine_id;
                customerDetails[insideCust].machine_up_time.customer_id =
                  val[i].customer_id;

                customerDetails[insideCust].machine_up_time.width = "60%";
                customerDetails[insideCust].machine_up_time.maxwidth = "330px";
                customerDetails[insideCust].machine_up_time.maxwidthOuter =
                  "510px";
                customerDetails[insideCust].machine_up_time.machine_state =
                  customerDetails[insideCust].machine_state;

                customerDetails[insideCust].machine_up_time.maxheight = "160px";
                customerDetails[insideCust].machine_up_time.maxheightOuter =
                  "300px";

                customerDetails[insideCust].machine_up_time.maxValue = maxValue;
                customerDetails[insideCust].machine_up_time.minValue =
                  "00 Hrs: 00 Mins";
                customerDetails[insideCust].machine_up_time.series = [series];
                customerDetails[
                  insideCust
                ].machine_up_time.originalValue = curr_value;
                customerDetails[insideCust].machine_up_time.timestamp =
                  customerDetails[insideCust].last_record_time || timeStamp;
                customerDetails[insideCust]["machine_up_time"]["isEnergy"] =
                  "false";
                listMachines.push(customerDetails[insideCust]);
              }
              val[i]["value_ind_cust"] = listMachines || [];

              console.log(
                "Checking success in condition",
                listMachines,
                val[i]
              );

              newValue.push(val[i]);
            }
          }
          const obj = Object.assign({}, newValue);

          console.log("Checking newvalue", newValue, obj);

          this.alertsData = newValue || [];
          console.log("checkign alert data", this.alertsData);
          // this.alertsData = obj || [];
        })
        .catch((error) => {
          this.showLoader = false;
          if (error.response && error.response.status === 401) {
            sessionStorage.clear();
            router.push("/login");
          } else {
            alert("internal error");
            console.log("axios error", error.message);
          }
        });
    },
  },
};
</script>
<style scoped>
@import "../assets/fonts/style.css";

@media screen and (min-width: 600px) {
  #div2 {
    display: none;
  }
  #ins1 {
    display: none;
  }
}

/* On screens that are 600px wide or less, the background color is olive */
@media screen and (max-width: 600px) {
  #div1 {
    display: none;
  }
  #ins2 {
    display: none;
  }
}

.block {
  display: block;
  width: 100%;
  border: none;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  text-align: left;
}
</style>
